import { CheckCircle, Users, Monitor, BarChart3 } from "lucide-react";
import { useTranslation } from "@/components/LanguageContext";

export default function AboutSection() {
  const { t } = useTranslation();
  const features = [
    { title: t("about.feat1"), desc: t("about.feat1d"), icon: CheckCircle },
    { title: t("about.feat2"), desc: t("about.feat2d"), icon: Users },
    { title: t("about.feat3"), desc: t("about.feat3d"), icon: Monitor },
    { title: t("about.feat4"), desc: t("about.feat4d"), icon: BarChart3 },
  ];

  return (
    <section id="sobre" data-testid="about-section" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
          <div className="relative">
            <img src="https://customer-assets.emergentagent.com/job_wp-landing-builder/artifacts/eqk0ezuq_image.png" alt="" className="w-full h-[420px] object-cover object-right-bottom rounded-lg" data-testid="about-image" />
            <div className="absolute -bottom-3 -right-3 w-24 h-24 bg-gradient-to-br from-[#00A8FF] to-[#F59E0B] rounded-lg opacity-20 -z-10" />
          </div>
          <div>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#00A8FF] mb-2">{t("about.label")}</p>
            <div className="section-divider mb-6" />
            <h2 className="font-['Outfit'] text-3xl md:text-4xl font-extrabold tracking-tight text-[#0A1628] mb-6">{t("about.title")}</h2>
            <p className="text-base leading-relaxed text-slate-500 mb-10">{t("about.desc")}</p>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-5">
              {features.map((f, i) => (
                <div key={i} className="flex items-start gap-3 p-3 rounded-lg hover:bg-slate-50 transition-colors" data-testid={`about-feat-${i}`}>
                  <div className="w-9 h-9 rounded-md bg-[#00A8FF]/10 flex items-center justify-center shrink-0">
                    <f.icon className="w-4.5 h-4.5 text-[#00A8FF]" />
                  </div>
                  <div>
                    <h4 className="font-['Outfit'] font-bold text-sm text-[#0A1628]">{f.title}</h4>
                    <p className="text-xs text-slate-400 mt-0.5">{f.desc}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
